import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  IconButton,
  Toolbar,
  Badge,
  Box,
  Divider,
  Drawer,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsIcon from "@mui/icons-material/Notifications";
import LogoutIcon from "@mui/icons-material/Logout";
import MobileMenuDrawer from "./MobileMenuDrawer.jsx";
import { DetailsToMenu } from "../components/Menu/DetailsToMenu.jsx";
import { NotificationContext } from "../components/Notifications/NotificationContext.jsx";

const MOBILE_DRAWER_WIDTH = 280;

const TopBar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { handleLogout } = useContext(DetailsToMenu);
  const { unreadCount } = useContext(NotificationContext);
  const navigate = useNavigate();

  const handleMobileDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleClickLogout = () => {
    handleLogout();
    localStorage.removeItem("authToken");
    localStorage.removeItem("selectedCitizen");
    localStorage.removeItem("clinician_name");
    localStorage.removeItem("lastRoute");
    localStorage.removeItem("userSelectedId");
    localStorage.removeItem("clinician_id");
    localStorage.removeItem("role");
    localStorage.removeItem("selectedStatisticsOption");
    navigate("/");
  };

  const handleNotificationsClick = () => {
    navigate("/notifications");
  };

  return (
    <>
      <AppBar
        elevation={0}
        position="static"
        sx={{
          bgcolor: "white",
          color: "black",
          flexShrink: 0,
        }}
      >
        <Toolbar>
          <IconButton
            aria-label="Open menu"
            edge="start"
            onClick={handleMobileDrawerToggle}
            sx={{ mr: 2, color: "black" }}
          >
            <MenuIcon />
          </IconButton>
          <Box flexGrow={1} />
          <Box display="flex" flexDirection="row">
            <IconButton
              size="large"
              aria-label={`show ${unreadCount} new notifications`}
              color="inherit"
              onClick={handleNotificationsClick}
            >
              <Badge badgeContent={unreadCount} color="error">
                <NotificationsIcon />
              </Badge>
            </IconButton>
            <IconButton
              size="large"
              color="inherit"
              onClick={handleClickLogout}
            >
              <LogoutIcon />
            </IconButton>
          </Box>
        </Toolbar>
        <Divider variant="middle" />
      </AppBar>

      <Drawer
        anchor="left"
        open={mobileOpen}
        onClose={handleMobileDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: MOBILE_DRAWER_WIDTH,
          },
        }}
      >
        <MobileMenuDrawer onNavigate={handleMobileDrawerToggle} />
      </Drawer>
    </>
  );
};

export default TopBar;
